export default __webpack_public_path__ + "static/media/tushar.0adc4ef4.jpg";